module.exports = __webpack_public_path__ + "img/shop_1.30df035e.png";